import React from 'react';
import { Link } from 'react-router-dom';
import './Dashboard.css';

import DashboardHeader from '../DashboardHeader/DashboardHeader.js';
import RankingList from '../RankingList/RankingList.js';
import RankingFilter from '../RankingFilter/RankingFilter.js';
import PointsAndMoney from '../PointsAndMoney/PointsAndMoney.js';
import TimeAndDistance from '../TimeAndDistance/TimeAndDistance.js';
import ProgressBonus from '../ProgressBonus/ProgressBonus.js';
import ActivitiesContribution from '../ActivitiesContribution/ActivitiesContribution.js';

const Dashboard = (props) =>{
  return (
    <React.Fragment>
      <DashboardHeader
        header="Dashboard"
        user={props.user}
        period={props.period}
        setPeriod={props.setPeriod}
      />
      <div className="Dashboard-content DashboardGrid">
        <div className="DashboardGridItem DashboardGridItem-summary">
          <div className="DashboardGridItem-header">
            <h4 className="DashboardGridItem-header__title">Company summary</h4>
          </div>
          {(props.period !== 'total') &&
          <div className="DashboardGridItem DashboardGridItem-progress">
            <ProgressBonus
              progress={props.progress}
              period={props.period}
            />
          </div>
          }
          <div className="DashboardGridItem DashboardGridItem-results">
            <PointsAndMoney
              pointsAndMoney={props.pointsAndMoney}
            />
          </div>

          <div className="DashboardGridItem DashboardGridItem-results">
            <TimeAndDistance
              timeAndDistance={props.timeAndDistance}
            />
          </div>

          <div className="DashboardGridItem-header">
            <h4 className="DashboardGridItem-header__title">Overall top disciplines</h4>
          </div>
          <div className="DashboardGridItem DashboardGridItem-contribution">
              <ActivitiesContribution
                categories={props.categories}
                categoriesResults={props.categoriesResults}
                pointsAndMoney={props.pointsAndMoney}
               />
          </div>
        </div>


        <div className="DashboardGridItem DashboardGridItem-ranking">
          <div className="DashboardGridItem-header">
            <h4 className="DashboardGridItem-header__title">Ranking</h4>
            <Link to="/dashboard/participants" className="DashboardGridItem-header__link">All participants</Link>
          </div>

          <div className="DashboardGridItem DashboardGridItem-rankingContent">
            <RankingFilter
              rankingCategory={props.rankingCategory}
              setRankingCategory={props.setRankingCategory}
              period={props.period}
              categories={props.categories}
              thisMonthCategories={props.thisMonthCategories}
              previousMonthCategories={props.previousMonthCategories}
            />

            <RankingList
              period={props.period}
              ranking={props.ranking}
              rankingLoading={props.rankingLoading}
            />
          </div>
        </div>
      </div>

    </React.Fragment>
  )
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/screens/bfmPanel/Dashboard/Dashboard.js